import SingleNews from '@/views/news/SingleNews'
import NewsHome from '@/views/news/NewsHome'
import NewsList from '@/views/news/NewsList'
import NewsCreate from '@/views/news/NewsCreate'

export default {
  path: '/nyheter',
  component: NewsHome,
  children: [
    {
      path: '',
      name: 'NewsList',
      props: true,
      component: NewsList,
      children: [
        {
          path: 'ny',
          name: 'createNews',
          props: true,
          component: NewsCreate,
        },
      ],
    },

    {
      path: ':id',
      name: 'SingleNews',
      props: true,
      component: SingleNews,
    },
  ],
}
